module.exports = __webpack_public_path__ + "static/headshot-grayscale-0d17d7dcbad463fd365b275eb8370fd9.png";